import { render } from "./SimpleTopbar.vue?vue&type=template&id=0d4b57e3&scoped=true"
import script from "./SimpleTopbar.vue?vue&type=script&lang=js"
export * from "./SimpleTopbar.vue?vue&type=script&lang=js"

import "./SimpleTopbar.vue?vue&type=style&index=0&id=0d4b57e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4b57e3"]])

export default __exports__